export default {
  inject: ['load'],
  data() {
    return {
      allSurveyCategories: [],
    };
  },
  methods: {
    getAllSurveyCategoriesFunction: function () {
      this.$store.dispatch('getAllSurveyCategories').then(() => {
        if (this.$store.state.surveyCategoryModule.successFlag) {
          this.allSurveyCategories = this.$store.state.surveyCategoryModule.allSurveyCategories;
        } else {
          if (this.$store.state.surveyCategoryModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.surveyCategoryModule.successFlag) {
                this.getAllSurveyCategoriesFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.surveyCategoryModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllSurveyCategoriesFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.surveyCategoryModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
